export const defaultQuotationTerms = [
  {
    title: 'PRICING & VALIDITY',
    points: [
      'Prices are valid for 3 days only from the date of the final quotation/PI unless otherwise specified terms.',
      'The order will be considered confirmed only upon receipt of the advance payment.'
    ]
  },
  {
    title: 'PAYMENT TERMS',
    points: [
      '30% advance payment upon order confirmation.',
      'Remaining Balance at time of final dispatch / against LC / Bank Guarantee (if applicable).',
      'Liquidated Damages @ 0.5% to 1% per WEEK will be charged on delayed payments beyond the agreed terms.'
    ]
  },
  {
    title: 'DELIVERY & DISPATCH',
    points: [
      'Standard delivery period as per the telecommunication with customer.',
      'Any delays due to unforeseen circumstances (force majeure, strikes, and transportation issues) will be communicated.'
    ]
  },
  {
    title: 'QUALITY & WARRANTY',
    points: [
      'Cables will be supplied as per IS and other applicable BIS standards/or as per the agreed specifications mentioned/special demand by the customer.',
      'Any manufacturing defects should be reported immediately, within 3 working days of receipt.',
      'Warranty: 12 months from the date of dispatch for manufacturing defects only in ISI mark products.',
      'The company is not responsible for damages due to improper handling, installation, or unauthorized modifications.'
    ]
  },
  {
    title: 'ORDER CANCELLATION & RETURNS',
    points: [
      'Orders once placed cannot be canceled after material processing has begun.',
      'Custom-made orders are non-returnable and non-refundable.',
      'Any returns will only be accepted if the product does not meet the agreed specifications.'
    ]
  },
  {
    title: 'INSPECTION & TESTING',
    points: [
      'Third-party inspection is allowed before dispatch at the Buyer’s cost.',
      'In-house quality tests and reports will be provided upon request.'
    ]
  },
  {
    title: 'FORCE MAJEURE',
    points: [
      'The company shall not be liable for failure to perform due to natural calamities, government restrictions, war, strikes, or any unavoidable circumstances beyond control.'
    ]
  },
  {
    title: 'DISPUTE RESOLUTION',
    points: [
      'Any disputes arising shall be subject to the jurisdiction of the Jabalpur-M.P. court only.',
      'Arbitration may be sought as per the Indian Arbitration Act, 1996 for dispute resolution.'
    ]
  }
]

